import layout from '@/layout'

export default {
  path: '/original',
  component: layout,
  redirect: '/original/originals',
  name: 'original',
  meta: {
    title: '原料（中央厨房）',
    icon: 'original'
  },
  children: [
    {
      path: '/original/originals',
      name: 'original_originals',
      component: () => import('@/views/original/originals/index'),
      meta: {
        title: '原料库',
        icon: 'original'
      }
    },
    {
      path: '/original/store_inventory',
      name: 'original_store_inventory',
      component: () => import('@/views/original/store_inventory/index'),
      meta: {
        title: '门店库存',
        icon: 'original'
      }
    },
    {
      path: '/original/transfer',
      name: 'original_transfer',
      component: () => import('@/views/original/transfer/index'),
      meta: {
        title: '门店调货',
        icon: 'original'
      }
    }
  ]
}
